import React, { useState, useEffect } from "react";
import axios from "axios";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { ActionFormatterComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
// import ExportIcon from "../../../components/Images/icons/Export_Icon_01"
import { toast } from "react-toastify";
import { RxReload } from "react-icons/rx";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import useTablePage from "../../../components/CommonComponents/useTablePage";

const AdvertisementList = (props) => {
   const { fetchRequest } = useMyContext()
   const headers = getItemToken('access_token')
   const BaseUrl = process.env.REACT_APP_Baseurl
   const listApi = `${BaseUrl}/admin/advertisement`
   const bannerToggle = `${BaseUrl}/admin/advertisement-status-update`

   const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
   const [type, setType] = useState(null)
   const [apiData, setApiData] = useState([]);
   const [loading, setLoading] = useState(true);
   const [showModal, setShowModal] = useState(false);
   const [sliderShowModal, setSliderShowModal] = useState(false);
   const [currentItem, setCurrentItem] = useState(null);
   const [modelClose, setModelClose] = useState(false);
   const [itemToDelete, setItemToDelete] = useState([]);
   const [withOutRefresh, setWithoutRefresh] = useState(false)
   const [total, setTotal] = useState('');
   const [selectAll, setSelectAll] = useState(false);

   const [advertiserId, setAdvertiserId] = useState(null);

   const [formData, setFormData] = useState({
      state: "formData",
      view_type: "list",
      view_type_option: [{
         name: "List",
         value: "list"
      },
      {
         name: "Gallery",
         value: "grid"
      }]
   })

   const fetchData = async () => {
      setLoading(true)
      await fetchRequest({
         method: 'GET',
         url: `${listApi}`,
         params: { type, page, limit, search: formData?.title },
         data: {},
      })
         .then(response => {
            const result = response;
            const updatedList = result?.data?.map((item) => {
               const UploadStatus = item?.uploaded_by_role;
               return {
                  ...item, uploaded_by_role: UploadStatus,
               };
            });
            setApiData(updatedList);
            setTotal(result?.pagination)
            setLoading(false)
         })
         .catch(error => {
            setLoading(false)
         })
   };

   const fetchAllData = async (type, find) => {
      const data = await fetchRequest({
         method: 'GET',
         url: `${listApi}`,
         params: {
            search: find === "ALL" ? null : formData?.title,
            type: null,
            page: 1,
            limit: find === "ALL" ? total?.count_all : total?.totalItems,
         },
         data: {},
      });

      let updatedList;

      if (find === "ALL") {
         // Export everything
         updatedList = data?.data || [];
      } else {
         // Export only selected rows
         if (!itemToDelete || itemToDelete.length === 0) {
            alert("Please select at least one row to export.");
            return;
         }
         updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
         if (!updatedList || updatedList.length === 0) {
            alert("Selected data not found.");
            return;
         }
      }

      const exportData = updatedList.map((item, index) => ({
         "S.NO": index + 1,
         "AD NAME": item?.ads_name,
         "AD POSITION": item?.ads_position,
         "STATUS": item?.status == 1 ? "ACTIVE" : "INACTIVE",
         "UPLOADED BY": item?.upload_on,
      }));

      if (type === "CSV") {
         await donwloadCSV(exportData, "ADVERTISEMENT-LIST");
      } else if (type === "PDF") {
         await videodownloadPDF(exportData, "ADVERTISEMENT-LIST", [
            "S.NO", "AD NAME", "AD POSITION", "STATUS", "UPLOADED BY"
         ]);
      } else if (type === "XLSX") {
         await videodownloadXLSX(exportData, "ADVERTISEMENT-LIST", [
            "S.NO", "AD NAME", "AD POSITION", "STATUS", "UPLOADED BY"
         ]);
      }
   };

   useEffect(() => {
      fetchData();
   }, [page, limit, formData?.title, withOutRefresh]);

   const singleDelete = (id) => {
      setModelClose(true);
      setItemToDelete([id]);
   };
   const closeModal = () => {
      setModelClose(!closeModal);
      setShowModal(false);
      setSliderShowModal(false);
      setItemToDelete([])
   };
   const openModal = () => {
      setModelClose(true);
   };

   const handleToggle = async (item) => {
      setCurrentItem(item);
      setSliderShowModal(true);
   };

   const columns = [
      {
         dataField: "adsName",
         text: "Ad Name",
         headerClasses: "",
         formatter: (cell, row) => <div >
            <p>{row?.ads_name}</p>
         </div>,
      },
      {
         dataField: "adsFormat",
         text: "Ad Position",
         rowStyle: "px-3",
         formatter: (cell, row) => <div >
            <p>{row?.ads_position}</p>
         </div>,
      },
      {
         dataField: "status",
         text: "Status",
         formatter: (cell, row) => <AdminSwitch name="status" checked={cell === 1} onChange={() => handleToggle(row)} id={row?.id} />
      },
      {
         dataField: "action",
         text: "Action",
         formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={`/ads-edit/`} action={singleDelete} />,
      }

   ];

   const options = {
      pageStartIndex: 1,
      paginationSize: 3,
      sizePerPage: 10,
   };

   const handleDelete = async () => {

      try {
         setLoading(true)
         const response = await axios.delete(
            `${process.env.REACT_APP_Baseurl}/admin/advertisement-delete/${itemToDelete}`,
            { headers: headers }
         );
         if (response?.data?.status === true) {
            toast.success(response.data.message);
            closeModal();
            setWithoutRefresh(!withOutRefresh);
            setLoading(false)
         }

      } catch (error) {
         toast.error("Failed to delete advertiser.");
         setLoading(false)
      }
   };

   const confirmToggle = async () => {
       setSliderShowModal(false);
       try {
         const formData = {};
         const newStatus = currentItem?.status === 1 ? 0 : 1;
         formData['id'] = currentItem?.id;
         formData['status'] = newStatus
         const response = await axios.post(`${bannerToggle}`, formData, { headers: headers });
         const result = response.data
         if (result.status) {
           setWithoutRefresh(!withOutRefresh);
           toast.success(result?.message);
           setCurrentItem(null);
         }
         else {
           toast.error(result?.message);
         }
       } catch (err) {
         var errorMessage = err?.response?.data?.message;
         toast.error(errorMessage);
       }
   };

   const handleInput = (e) => {
      const { type, name, value, checked } = e.target
      if (type === "search") {
         setFormData((prev) => ({
            ...prev,
            [name]: value,
         }))
      }
      if (type === 'select-one') {
         setFormData((prev) => ({
            ...prev,
            [name]: value,
         }));
      }
   }

   const handleDeletedata = () => {
      handleDelete();
      closeModal();
   };

   const reloadAction = () => {
      setWithoutRefresh(prev => !prev)
   }

   const handleRowSelect = (rowId) => {
      if (itemToDelete.includes(rowId)) {
         setItemToDelete(itemToDelete.filter((id) => id !== rowId));
      } else {
         setItemToDelete([...itemToDelete, rowId]);
      }
   };

   const handleSelectAll = () => {
      if (itemToDelete.length === apiData.length) {
         setItemToDelete([]);
      } else {
         setItemToDelete(apiData.map((row) => row.id));
      }
   };

   const handleSort = (field) => {
      const sortedData = [...apiData].sort((a, b) => {
         if (a[field] < b[field]) return -1;
         if (a[field] > b[field]) return 1;
         return 0;
      });
      setApiData(sortedData);
   };

   const handleAll = () => {
      setSelectAll(!selectAll);
      setItemToDelete(selectAll ? [] : apiData?.map((item) => item?.id));
   };

   const selectRow = {
      mode: "checkbox",
      onSelect: (row, isSelect) => {
         if (row) {
            if (isSelect) {
               setItemToDelete([...itemToDelete, row.id]);
            } else {
               setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
            }
         }
      },
      style: { width: '30px' },
      selected: itemToDelete,
      selectionHeaderRenderer: ({ mode, checked }) => (
         <div>
            <input type="checkbox" checked={checked} onChange={handleAll} />
         </div>
      ),
   };

   return (
      <>
         {modelClose && <AdminDeleteModal headingText={"Confirm Delete"} message={"Are you sure you want to delete this items"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={"Delete"} />}
         <AdminNavbar heading={"All Advertisements"} totalDataLength={total?.totalRecords} deleteCount={itemToDelete?.length} deleteMethod={openModal} />
         {showModal && (
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
               <div className="modal-dialog">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h5 className="modal-title">Confirm Deletion</h5>
                        <button
                           type="button"
                           className="btn-close"
                           aria-label="Close"
                           onClick={closeModal}
                        ></button>
                     </div>
                     <div className="modal-body">
                        <p>Are you sure you want to delete this advertiser?</p>
                     </div>
                     <div className="modal-footer">
                        <button
                           type="button"
                           className="btn btn-secondary"
                           onClick={closeModal}
                        >
                           No
                        </button>
                        <button
                           type="button"
                           className="btn btn-danger"
                           onClick={handleDelete}
                        >
                           Yes
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         )}
         {sliderShowModal && <AdminSliderModal modelClose={sliderShowModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.banner} />}
         <div className='theme-bg-color p-3 rounded-3 mb-5'>
            <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
               <input type='search' placeholder='Search' name="title" className='rounded-3  theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} id='searchInput' />
               <div className=' d-flex align-items-center'>
                  <button className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} onClick={reloadAction} id='reloadButton'>
                     <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                     <AdminTooltip  text="Refresh"  top={"-41px"} className="d-none custom-tool-tip" />

                  </button>
                  <div className="dropdown d-block ms-2 " key={"2"}>
                     <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                        <span className="fw-bolder text-white">Export</span>
                        {/* <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" /> */}
                     </button>
                     <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                        <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => fetchAllData("CSV")}>CSV</li>
                        <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => fetchAllData("PDF")}>PDF</li>
                        <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => fetchAllData("XLSX")}>XLSX </li>
                     </ul>
                  </div>
                  <div className="dropdown d-block ms-2 " key={"2"}>
                     <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                        <span className="fw-bolder text-white">Export all</span>
                        {/* <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" /> */}
                     </button>
                     <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                        <li className="dropdown-item theme-text-color" id='exportAllCSV' onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                        <li className="dropdown-item theme-text-color" id='exportAllPDF' onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                        <li className="dropdown-item theme-text-color" id='exportAllXLSX' onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
                     </ul>
                  </div>
               </div>
            </div>

            <AdminTable data={apiData}
               loading={loading}
               options={options}
               handlePageChange={handlePageChange}
               page={page}
               pagination={total}
               handleSizePerPageChange={handleSizePerPageChange}
               columns={columns}
               limit={limit}
               selectRow={selectRow}
               multiSelect
               onRowSelect={handleRowSelect}
               onSort={handleSort}
               onSelectAll={handleSelectAll}
               viewType={formData?.view_type}
            />
         </div>
      </>
   );
};

export default AdvertisementList;